import { onlyLatinCharsDigitsSpecialSymbolsRule } from '../../../../utils/form.constants';

export const nameRules = [
  onlyLatinCharsDigitsSpecialSymbolsRule,
  {
    required: true,
    message: 'Please enter name',
    validateTrigger: 'onSubmit',
    whitespace: true,
  },
  {
    min: 4,
    message: 'Minimum 4 characters',
    validateTrigger: 'onSubmit',
  },
  {
    max: 256,
    message: 'Maximum 256 characters',
    validateTrigger: 'onSubmit',
  },
];

export const addressRules = [
  onlyLatinCharsDigitsSpecialSymbolsRule,
  {
    required: true,
    validateTrigger: 'onSubmit',
    whitespace: true,
  },
  {
    max: 256,
    message: 'Maximum 256 characters',
    validateTrigger: 'onSubmit',
  },
];
